const Guard1000 = () =>
  import(/* webpackChunkName: "guard-1000" */ '@/components/device/guard-1000/index');
const EditGuard1000 = () =>
  import(/* webpackChunkName: "guard-1000" */ '@/components/device/edit-guard-1000');
const Guard1000PanelDefault = () =>
  import(/* webpackChunkName: "guard-1000" */ '@/components/device/guard-1000/fault-panel');
const Guard1000Fault = () =>
  import(/* webpackChunkName: "guard-1000" */ '@/components/device/guard-1000/fault');
const Guard1000FeederDiagram = () =>
  import(
    /* webpackChunkName: "guard-1000-diagram" */ '@/components/device/guard-1000/fault-feeder-diagram'
  );

export default [
  {
    path: '/project/:projectCode/substation/:substationCode/guards1000/:externalGuardId/',
    component: Guard1000,
    meta: { showWide: true },
    children: [
      {
        path: 'edit',
        name: 'EditGuard1000',
        component: EditGuard1000,
        meta: { showWide: true }
      },
      {
        path: 'fault_panel',
        name: 'Guard1000PanelDefault',
        component: Guard1000PanelDefault,
        meta: { showWide: true }
      },
      {
        path: 'panel/phase_number/:phaseNumber/feeder_number/:feederNumber',
        name: 'Guard1000Fault',
        component: Guard1000Fault,
        meta: { showWide: true },
        props: true
      }
    ]
  },
  {
    path:
      '/project/:projectCode/substation/:substationCode/guards1000/:externalGuardId/feeder_number/:feederNumber/diagram',
    name: 'Guard1000FeederDiagram',
    component: Guard1000FeederDiagram,
    meta: { showWide: true }
  }
];
